module.exports = __webpack_public_path__ + "img/logo.97a419f5.png";